const chartLoadingIndicator =
  "<div class='d-flex align-items-center justify-content-center py-5' role='status'>" +
    "<div class='spinner-grow text-dark'></div><span class='ml-2'>Loading chart...</span>" +
  "</div>";

document.addEventListener("DOMContentLoaded", () => {
  initialize_department_and_designation_options();
  set_month_wise_gross_salary_graph(
    $(".month-wise-gross-salary-filter").val(),
    $(".gross-salary-currency-filter").val()
  );
  initialize_activity_related_to_graph();
});

$(document).on(
  "change",
  ".month-wise-gross-salary-filter, .gross-salary-currency-filter",
  () => {
    set_month_wise_gross_salary_graph(
      $(".month-wise-gross-salary-filter").val(),
      $(".gross-salary-currency-filter").val()
    );
  }
);

$(document).on("reset", "#data_insight_filters_form", (e) => {
  hide_and_clear_dropdown($("#allowances_dropdown"));
  hide_and_clear_dropdown($("#claim_types_dropdown"));
  initialize_activity_related_to_graph();
  e.preventDefault();
});

$(document).on("ajax:beforeSend", "#data_insight_filters_form", () => {
  $("#activity-related-to-chart").html(chartLoadingIndicator);
  $("#activity-related-to-chart-summary").empty();
});

$(document).on("ajax:error", "#data_insight_filters_form", () => {
  $("#activity-related-to-chart").html("<p class='text-center text-danger py-5'>Unable to load chart.</p>");
});

const initialize_department_and_designation_options = () => {
  $("#department-options").on("change", function () {
    render_designation_options($(this).val());
  });
};

const render_designation_options = (selected_departments) => {
  if (window.location.pathname.split("/").at(-1) === "data_insights") {
    $.ajax({
      type: "GET",
      url: "/data_insights",
      dataType: "script",
      data: {
        department_ids: selected_departments,
        get_active_designations: true,
      },
    });
  }
};

const initialize_activity_related_to_graph = () => {
  if (window.location.pathname.split("/").at(-1) === "data_insights") {
    const isFinalSettlement = new URLSearchParams(window.location.search).get("analytic_category") === "final_settlement";
    const defaultFilter = isFinalSettlement ? "Gross Salary" : "Net Salary";
    $("#activity_related_to").val(defaultFilter).change();
    $("#designation-options").val("").multiselect("refresh");
    var allOptions = $("#department-options").find("option").not(":disabled");
    var valueArray = $.map(allOptions, function (option) {
      return option.value;
    });
    valueArray = valueArray.slice(0, 10);
    $("#analytics_from").val(
      $("#analytics_from").data("defualt-fiscal-year-start")
    );
    $("#analytics_till").val(
      $("#analytics_till").data("defualt-fiscal-year-end")
    );
    $("#department-options")
      .val(valueArray)
      .multiselect("refresh")
      .trigger("change");
    $("#apply-data_insight_filters").click();
  }
};

const set_month_wise_gross_salary_graph = (month_year, currency) => {
  if (window.location.pathname.split("/").at(-1) === "data_insights") {
    $.ajax({
      type: "GET",
      url: "/data_insights",
      dataType: "script",
      beforeSend: () => {
        $("#gross-salary-chart").html(chartLoadingIndicator);
      },
      error: () => {
        $("#gross-salary-chart").html("<p class='text-center text-danger py-5'>Unable to load chart.</p>");
        $(".net-gross-salary-amount, .avg-gross-salary-amount").empty();
      },
      data: {
        month_year: month_year,
        chart_type: "Month-wise Gross Salary",
        currency: currency,
        analytic_category: new URLSearchParams(window.location.search).get("analytic_category"),
      },
    });
  }
};
